import axios from 'axios';
import config from '../config';

const GetAll = async (page, count, keyword) => {
    try {
        const token = localStorage.getItem("oojwt");
        const response = await axios.get(config.apiUrl + 'epin-purchase/all?page=' + page + '&resultCount=' + count + '&keyword=' + keyword, {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        });
        if (response.status === 200) {
            console.log(response.data);
            return {
                status: 200,
                epinPurchases: response.data.epinPurchases,
                total: response.data.pagination.totalResults,
                totalPages: response.data.pagination.totalPages
            };
        }
    } catch (error) {
        console.log(error);
        return {
            status: 401,
            message: error.response.data.message
        };

    }
}

const Add = async (userId, levelId, price, unit, purchaseDate, remarks) => {
    try {
        const data = new FormData();
        data.append("userId", userId);
        data.append("levelId", levelId);
        data.append("price", price);
        data.append("unit", unit);
        data.append("purchaseDate", purchaseDate);
        data.append("remarks", remarks);

        console.log("Data in service : " + data);
        const token = localStorage.getItem("oojwt");
        const response = await axios.post(config.apiUrl + 'epin-purchase/add', data,
            {
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'multipart/form-data'
                }
            });
        console.log(response);
        if (response.status === 201) {
            console.log("Epin purchase added successfully");
            return {
                status: 200,
                message: response.data.message,
                epinPurchase: response.data.epinPurchase
            };
        }
    } catch (error) {
        console.log(error);
        return {
            status: 401,
            message: error.response.data.message

        };
    }
}

//get latest epin purchase by count
const GetLatestEpinPurchases = async (count) => {
    try {
        const token = localStorage.getItem("oojwt");
        const response = await axios.get(`${config.apiUrl}epin-purchase/get-latest?count=${count}`,
            {
                headers: {
                    'Authorization': 'Bearer ' + token
                }
            });
        if (response.status === 200) {
            return {
                status: 200,
                epinPurchases: response.data.epinPurchases,
                overallTotal: response.data.overallTotal
            };
        }
    } catch (error) {
        console.log(error);
        return {
            status: 401,
            message: error.response.data.message
        };
    }
}


//want get by user id with pagination and keyword
const GetByUserId = async (userId, page, count, keyword) => {
    try {
        const token = localStorage.getItem("oojwt");
        const response = await axios.get(`${config.apiUrl}epin-purchase/get-by-user-id?userId=${userId}&page=${page}&resultCount=${count}&keyword=${keyword}`, {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        });
        if (response.status === 200) {
            return {
                status: 200,
                epinPurchases: response.data.epinPurchases,
                total: response.data.pagination.totalResults,
                totalPages: response.data.pagination.totalPages,
                overallUnitTotal: response.data.overallUnitTotal
            };
        }
    } catch (error) {
        console.log(error);
        return {
            status: 401,
            message: error.response.data.message
        };

    }
}

export { GetAll, Add, GetLatestEpinPurchases, GetByUserId };